import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

const MODAL_OVERLAY_PADDING = 16;
const MODAL_INNER_PADDING = 16;

export const StyledModalOverlay = styled.div`
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100vw;
  height: 100vh;
  background-color: rgba(67, 89, 147, 0.7);
  padding: ${MODAL_OVERLAY_PADDING}px;
  left: 0;
  top: 0;
  z-index: 10;
`;

export const StyledModal = styled.div`
  position: relative;
  padding: ${MODAL_INNER_PADDING}px 0;
  border-radius: 4px;
  flex-grow: 1;
  box-shadow:
    0px 15px 12px rgba(0, 0, 0, 0.22),
    0px 19px 38px rgba(0, 0, 0, 0.3);
  background-color: ${colorsPalettes.carbon[0]};
  display: flex;
  flex-wrap: wrap;
  max-height: calc(100vh - ${MODAL_OVERLAY_PADDING * 2}px);
  overflow: auto;
`;

export const StyledModalHeader = styled.header<{ hasCloseBtn?: boolean }>`
  width: ${({ hasCloseBtn }) => (hasCloseBtn ? 'calc(100% - 30px)' : '100%')};
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  padding: 0 ${MODAL_INNER_PADDING}px;
`;

export const StyledModalHeading = styled.h4`
  ${setFontVariant('h5', colorsPalettes.carbon[500])};
  margin: 0 0 4px 0;
`;

export const StyledModalSubheading = styled.div`
  width: 100%;
  position: relative;
  ${setFontVariant('caption', colorsPalettes.carbon[300])};
  margin: -24px 0 18px;
  padding: 0px 60px 0 16px;

  &::after {
    position: absolute;
    left: 0;
    bottom: -18px;
    display: block;
    content: '';
    width: 100%;
    border-bottom: 1px solid ${colorsPalettes.carbon[50]};
  }
`;

export const StyledCloseModalButton = styled.button`
  display: flex;
  position: absolute;
  top: 16px;
  right: 16px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  padding: 8px;
  border: none;
  box-shadow: none;
  background-color: ${colorsPalettes.carbon[0]};
  transition: background-color 0.2s ease-in-out;
  cursor: pointer;

  &:hover {
    background-color: rgba(181, 190, 198, 0.2);
  }
`;

export const StyledModalContent = styled.div<{ horizontalPadding?: number }>`
  width: 100%;
  padding: ${({ horizontalPadding = MODAL_INNER_PADDING }) => `0 ${horizontalPadding}px`};
`;

export const StyledModalFooter = styled.div<{ justifyContent?: string }>`
  display: flex;
  justify-content: ${({ justifyContent }) => justifyContent || 'flex-end'};
  align-items: center;
  gap: 8px;
  width: 100%;
  margin-top: 20px;
  padding: 0 ${MODAL_INNER_PADDING}px;
`;
